import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'offers'
const verb = 'get'

export default class OspreyOffersSearchSuggestion extends BaseAction {
    constructor(dataKey) {
        const id = 'bfa818a2-6a3c-492d-b74b-ab71d4a4b3eb'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    getSearchSuggestion(params) {
        this.params = Object.assign({
            fields: 'id,name',
            sf: 'name',
            sd: 'asc',
            archived: false
        }, params)

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/offers/offers-search-suggestion.js